import { RouteObject } from "react-router";
import TilsynsErklaeringDesign from "@/routes/design/TilsynsErklaeringDesign";
import KlientkontoerklaeringDesign from "@/routes/design/KlientkontoerklaeringDesign";
import { ROUTES } from "@/constants/routes";

export const designRoutes: RouteObject[] = [
  {
    id: ROUTES.design.id,
    path: "/design",
    children: [
      {
        id: ROUTES.teDesign.id,
        path: "/design/tilsynserklaering",
        element: (
          <div className="container-xxl mt-3 mb-7">
            <TilsynsErklaeringDesign />
          </div>
        ),
      },
      {
        id: ROUTES.kkeDesign.id,
        path: "/design/klientkontoerklaering",
        element: <KlientkontoerklaeringDesign />,
      },
    ],
  },
];
